import React from 'react';
import { Button, Result } from 'antd';

function Page404(props) {
  return (
    <Result
      status="404"
      title="404"
      subTitle="找不到对应的页面"
      extra={
        <Button type="primary" onClick={props.history.goBack}>
          返回上一页
        </Button>
      }
    />
  );
}

export default Page404;
